import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MarsEditorDataQuestionsService } from '../../questions-services/mars-editor-data-questions.service';
import { MarsLicenseService } from 'app/mars/services/mars-licenses.service';
import { DynamicFormComponent } from 'core/components';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-mars-license-editor',
  templateUrl: './mars-license-editor.component.html',
  styleUrls: ['./mars-license-editor.component.scss']
})
export class MarsLicenseEditorComponent implements OnInit {
  public questions: any;
  @Input() license: any;
  @Input() client: any;
  @Input() match: any;
  @Output() licenseUpdated = new EventEmitter();
  @ViewChild('form', { static: false }) public form: DynamicFormComponent;
  public routeSubscription: Subscription;
  constructor(
    private marsEditorDataQuestionsService: MarsEditorDataQuestionsService,
    private marsLicenseService: MarsLicenseService
  ) {}

  public ngOnInit(): void {
    this.questions = this.marsEditorDataQuestionsService.getQuestions(this.license, this.client, this.match);
  }

  onSubmit(data) {
    this.marsLicenseService.updateLicense(data).then(() => {
      this.form.submitted(null);
      this.licenseUpdated.emit();
    });
  }
}
